module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c White.1cb45262.png";